import React from 'react';
type PageHeaderProps = {
  kanji: string;
  eyebrow: string;
  title: string;
  intro?: string;
};
export function PageHeader({
  kanji,
  eyebrow,
  title,
  intro
}: PageHeaderProps) {
  return <div className="relative overflow-hidden border-b border-gold/15 bg-panel" data-id="element-87" data-mp="3rec5xi4dwjfd">
      <span aria-hidden className="pointer-events-none absolute -right-4 top-1/2 -translate-y-1/2 select-none font-jp text-[9rem] leading-none text-white/[0.04] sm:text-[12rem]" data-id="element-88" data-mp="3rc9fwy38eqan">
        {kanji}
      </span>
      <div className="relative mx-auto max-w-shell px-5 py-14 lg:px-8 lg:py-20" data-id="element-89" data-mp="2trmwwob9l6k0">
        <p className="font-display text-xs uppercase tracking-[0.3em] text-crimson" data-id="element-90" data-mp="38fhsccgnpp0s">{eyebrow}</p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl font-bold uppercase tracking-[0.04em] text-bone lg:text-5xl" data-id="element-91" data-mp="33pb62j9maglp">
          {title}
        </h1>
        {intro && <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted" data-id="element-92" data-mp="2fxm9gqprj5yy">{intro}</p>}
      </div>
    </div>;
}